// portal/auth import
import esriConfig from "@arcgis/core/config.js";
import esriId from "@arcgis/core/identity/IdentityManager.js";
import OAuthInfo from "@arcgis/core/identity/OAuthInfo.js";
import { useEffect } from "react";

export async function AuthFunc() {
  esriConfig.portalUrl = 'https://aus.gis.arcadis.com/portal'
  
  useEffect(()=>{
    const appInfo = new OAuthInfo({
      appId: "7dEHm0SPXUT2Y2jE",
      flowType: 'auto',
      portalUrl: esriConfig.portalUrl
      // popup: false,
      // If using a callback page other than the default one,
      // make sure it supports the authentication type used.
    });
    esriId.registerOAuthInfos([appInfo]);
  })
  return
}

// export 